// extracted by mini-css-extract-plugin
module.exports = {"change-value-container":"changeInMetric_change-value-container__3arM_","arrow":"changeInMetric_arrow__lQeJM","value-text":"changeInMetric_value-text__2Xpw3"};